<template>
    <div>
        <div class="rich_text" v-html="richText" @click="handleImageClick"></div>
        <!-- 图片预览 -->
        <div class="preview-overlay" :class="{ active: showPreview }" @click.self="closePreview">
            <div class="preview-container">
                <button class="close-btn" @click="closePreview">&times;</button>
                <img :src="currentImage" class="preview-image" ref="previewImg">
                <div class="navigation">
                    <button class="nav-btn" @click="prevImage" :disabled="currentIndex <= 0">❮</button>
                    <button class="nav-btn" @click="nextImage"
                        :disabled="currentIndex >= imageUrls.length - 1">❯</button>
                </div>
                <div class="image-counter">{{ currentIndex + 1 }} / {{ imageUrls.length }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5PriviewImg',
    props: {
        richText: {}
    },

    data() {
        return {
            imageUrls: [],
            currentImage: '',
            currentIndex: 0,
            showPreview: false
        };
    },

    mounted() {
        this.extractImages();
    },

    methods: {
        extractImages() {
            // 从富文本中提取所有图片URL
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.richText, 'text/html');
            const images = doc.querySelectorAll('img');
            this.imageUrls = Array.from(images).map(img => img.src);
        },
        handleImageClick(event) {
            if (event.target.tagName === 'IMG') {
                const imgUrl = event.target.src;
                this.currentIndex = this.imageUrls.indexOf(imgUrl);
                this.currentImage = imgUrl;
                this.showPreview = true;
                // 阻止滚动穿透
                document.body.style.overflow = 'hidden';
            }
        },
        prevImage() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.currentImage = this.imageUrls[this.currentIndex];
            }
        },
        nextImage() {
            if (this.currentIndex < this.imageUrls.length - 1) {
                this.currentIndex++;
                this.currentImage = this.imageUrls[this.currentIndex];
            }
        },
        closePreview() {
            this.showPreview = false;
            // 恢复页面滚动
            document.body.style.overflow = '';
        },
        handleKeydown(event) {
            if (!this.showPreview) return;

            switch (event.key) {
                case 'Escape':
                    this.closePreview();
                    break;
                case 'ArrowLeft':
                    this.prevImage();
                    break;
                case 'ArrowRight':
                    this.nextImage();
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.rich_text{
    overflow-wrap: anywhere;
}
.preview-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.preview-overlay.active {
    opacity: 1;
    pointer-events: all;
}

.preview-container {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.preview-image {
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
}

.close-btn {
    position: absolute;
    top: -40px;
    right: 0;
    background: transparent;
    border: none;
    color: white;
    font-size: 2rem;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.navigation {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
}

.nav-btn {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: none;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 1.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.nav-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.nav-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
    transform: none;
}

.image-counter {
    color: white;
    font-size: 1.1rem;
    margin-top: 15px;
    background: rgba(255, 255, 255, 0.2);
    padding: 5px 15px;
    border-radius: 20px;
}

.instructions {
    background: #e3f2fd;
    padding: 20px;
    border-radius: 8px;
    margin-top: 30px;
}

.instructions h2 {
    color: #1565c0;
    margin-bottom: 15px;
}

.instructions ul {
    padding-left: 20px;
}

.instructions li {
    margin-bottom: 10px;
    line-height: 1.6;
}

.footer {
    text-align: center;
    margin-top: 40px;
    color: #7f8c8d;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .container {
        padding: 10px;
    }

    h1 {
        font-size: 2rem;
    }

    .card {
        padding: 20px;
    }

    .nav-btn {
        width: 40px;
        height: 40px;
        font-size: 1.2rem;
    }
}
</style>